import React, { useState, useContext } from "react";
import { Link, Navigate } from "react-router-dom";
import { Row, Col, Form, Button, Alert } from "react-bootstrap";

import { Context } from "../../../context/AuthContext";
import { BoletimContext } from "../../../context/BoletimContext";
import LoadSpinner from "../../../components/LoadSpinner/LoadSpinner";
import api from "../../../Utils/api";

const FormLogin = () => {
  const { authenticated, setAuthenticated, setOfflineMode, municipio, setMunicipio } =
    useContext(Context);
  const { carregarRascunho } = useContext(BoletimContext);

  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [erroShow, setErroShow] = useState(false);
  const [erroMessage, setErroMessage] = useState("");
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErroShow(false);
    setErroMessage("");

    try {
      const response = await api.post("/login", {
        userEmail: userEmail.trim().toLowerCase(),
        userPassword,
      });
      setAuthenticated(response.data.authenticated);
      setOfflineMode(false);

      localStorage.setItem("x-access-token", response.data.token);
      localStorage.setItem("x-user-municipio", municipio);
      localStorage.setItem("x-user-mat-id", response.data.userID);
      localStorage.setItem("x-user-id", response.data.userRecordId);
      localStorage.setItem("x-user-tipo", response.data.userTipo);
      carregarRascunho();
    } catch (error) {
      setErroMessage(error.response?.data?.message || "Erro ao autenticar");
      setErroShow(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (authenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <main className="login-center">
      <Row className="w-100 justify-content-center">
        <Col xs={11} sm={8} md={6} lg={4}>
          <Form onSubmit={handleLogin}>
            <h5 className="bo-section-title text-center mb-3">
              Acesso ao Sistema
            </h5>
            {erroShow && <Alert variant="danger">{erroMessage}</Alert>}
            <LoadSpinner visible={isLoading} />

            <div className="bo-field">
              <label htmlFor="login-municipio">Município</label>
              <select
                id="login-municipio"
                name="municipio"
                value={municipio}
                onChange={(e) => {
                  setMunicipio(e.target.value);
                  localStorage.setItem(
                    "x-user-municipio",
                    e.target.value
                  );
                }}
              >
                {[
                  "Balsas",
                  "Riachão",
                  "Fortaleza dos Nogueiras",
                  "Nova Colinas",
                  "Feira Nova",
                  "São Pedro dos Crentes",
                  "Alto Parnaíba",
                  "Tasso Fragoso",
                  "Batavo",
                ].map((cidade) => (
                  <option key={cidade} value={cidade}>
                    {cidade}
                  </option>
                ))}
              </select>
            </div>

            <div className="bo-field">
              <label htmlFor="login-email">E-mail</label>
              <input
                id="login-email"
                name="userEmail"
                type="email"
                inputMode="email"
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                required
              />
            </div>

            <div className="bo-field">
              <label htmlFor="login-password">Senha</label>
              <input
                id="login-password"
                name="userPassword"
                type="password"
                autoComplete="current-password"
                value={userPassword}
                onChange={(e) => setUserPassword(e.target.value)}
                required
              />
            </div>

            <Button
              type="submit"
              className="bo-primary-btn mt-2"
              disabled={isLoading}
            >
              Entrar
            </Button>
            <p className="text-center mt-3 mb-0">
              Ainda não tem acesso? <Link to="/registro">Solicitar cadastro</Link>
            </p>
          </Form>
        </Col>
      </Row>
    </main>
  );
};

export default FormLogin;
